import { WELCOME_POPUP_IS_OPEN } from '../actionTypes'

const initialState = false

export default (state = initialState, action) => {
  if (action.type !== WELCOME_POPUP_IS_OPEN) return state
  return action.payload
}
